module.exports = __webpack_public_path__ + "img/eventIcon.e1e7b07f.svg";